import Swiper from "swiper";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

if (document.querySelector('.about-swiper')) {
    new Swiper('.about-swiper', {
        modules: [Navigation],
        centeredSlides: true,
        spaceBetween: 5,
        slidesPerView: 1,
        grabCursor: true,
        loop: true,
        breakpoints: {
            992: {
                centeredSlides: false,
                slidesPerView: 3,
            },
            1440: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 15
            }
        }
    });
}

if (document.querySelector('.adverting-swiper')) {
    new Swiper('.adverting-swiper', {
        centeredSlides: true,
        spaceBetween: 5,
        slidesPerView: 1,
        grabCursor: true,
        loop: true,
        breakpoints: {
            992: {
                centeredSlides: false,
                slidesPerView: 3,
            },
            1440: {
                slidesPerView: 4,
                centeredSlides: false,
                spaceBetween: 10
            }
        }
    });
}

if (document.querySelector('.partners-swiper-top')) {
    new Swiper('.partners-swiper-top', {
        modules: [Autoplay],
        loop: true,
        allowTouchMove: false,
        speed: 4000,
        slidesPerView: 3,
        spaceBetween: 10,
        autoplay: {
            delay: 0,
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
            },
            1440: {
                slidesPerView: 5,
            },
            1920: {
                slidesPerView: 6
            }
        }
    });
}

if (document.querySelector('.partners-swiper-bottom')) {
    new Swiper('.partners-swiper-bottom', {
        modules: [Autoplay],
        loop: true,
        allowTouchMove: false,
        slidesPerView: 2,
        spaceBetween: 10,
        speed: 6200,
        autoplay: {
            delay: 0,
            reverseDirection: true
        },

        breakpoints: {
            767: {
                speed: 4000,
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
            1440: {
                slidesPerView: 5,
            },
            1920: {
                slidesPerView: 6
            }
        }
    });
}

if (document.querySelector('.team-swiper')) {
    new Swiper('.team-swiper', {
        modules: [FreeMode, Navigation],
        spaceBetween: 7,
        slidesPerView: 1,
        grabCursor: true,
        freeMode: {
            enabled: true,
            sticky: true,
        },
        watchSlidesProgress: true,
        resistanceRatio: 0.85,
        navigation: {
            nextEl: ".team-section .next",
            prevEl: ".team-section .prev"
        },
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            992: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1920: {
                slidesPerView: 4,
                spaceBetween: 20
            }
        }
    });
}

if (document.querySelector('.single-blog-swiper')) {
    new Swiper('.single-blog-swiper', {
        spaceBetween: 35,
        slidesPerView: 3
    });
}
